import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComponent = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M.988 22.942S2.4 21.485 2.55 17.73a3.81 3.81 0 0 1 1.089-2.743 3.75 3.75 0 0 1 5.3 5.3 8.838 8.838 0 0 1-7.951 2.655h0Z",
			stroke: "#262626",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5,
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.2 1.729a2.771 2.771 0 0 0-4.067.162L7.7 14.163a3.752 3.752 0 0 1 2.087 2.118L22.039 5.8a2.771 2.771 0 0 0 .16-4.071v0Z",
			stroke: "#262626",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5,
			clipRule: "evenodd"
		})
	]
});
export const ReactComponent = SvgComponent;
export default "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22none%22%20viewBox%3D%220%200%2024%2024%22%3E%3Cpath%20d%3D%22M.988%2022.942S2.4%2021.485%202.55%2017.73a3.81%203.81%200%200%201%201.089-2.743%203.75%203.75%200%200%201%205.3%205.3%208.838%208.838%200%200%201-7.951%202.655h0Z%22%20stroke%3D%22%23262626%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke-width%3D%221.5%22%20clip-rule%3D%22evenodd%22%2F%3E%3Cpath%20d%3D%22M22.2%201.729a2.771%202.771%200%200%200-4.067.162L7.7%2014.163a3.752%203.752%200%200%201%202.087%202.118L22.039%205.8a2.771%202.771%200%200%200%20.16-4.071v0Z%22%20stroke%3D%22%23262626%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke-width%3D%221.5%22%20clip-rule%3D%22evenodd%22%2F%3E%3C%2Fsvg%3E";
